import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CustomIcon from "../../CustomIcon/CustomIcon";
import { infoToolTipCardOptions } from "../../../interfaces/infoToolTipCardOptions";
import * as Styles from "./ToolTipCard.styles";

export default function ToolTipCard({ cardTitle, cardlistItems, cardSubtitle }: infoToolTipCardOptions) {
  return (
    <div>
      <Styles.InfoToolTipCardHeader>
        <Styles.IntoToolTipCardTitle>
          <CustomIcon Icon={ErrorOutlinedIcon} size="var(--icon-size-sm-plus)" color="currentColor" />
          <Styles.CardTitleText>{cardTitle}</Styles.CardTitleText>
        </Styles.IntoToolTipCardTitle>
        <Styles.CardSubTitleText>{cardSubtitle}</Styles.CardSubTitleText>
      </Styles.InfoToolTipCardHeader>

      <Styles.InfoToolTipCardBody>
        {cardlistItems.map((item, index) => (
          <Styles.InfoToolTipCardBodyListItem key={index}>
            <CustomIcon Icon={CheckCircleRoundedIcon} size={"var(--icon-size-sm-plus)"} color="var(--color-primary)" />
            <Styles.InfoToolTipCardBodyListItemText>{item.text}</Styles.InfoToolTipCardBodyListItemText>
          </Styles.InfoToolTipCardBodyListItem>
        ))}
      </Styles.InfoToolTipCardBody>
    </div>
  );
}
